(() => {
  const videos = new Set();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');

  function loadVideo(video) {
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }
    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
      video.load();
    }
  }

  function updatePlayback(video) {
    if (video.dataset.wm2Visible === 'true' && !document.hidden && !motion.matches) {
      loadVideo(video);
      video.muted = true;
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }

  const nearby = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      if (motion.matches) {
        if (video.dataset.poster) video.poster = video.dataset.poster;
      } else {
        loadVideo(video);
      }
      nearby.unobserve(video);
    });
  }, { rootMargin: '300px 0px', threshold: 0 }) : null;

  const visible = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.dataset.wm2Visible = String(entry.isIntersecting && entry.intersectionRatio >= 0.2);
      updatePlayback(entry.target);
    });
  }, { threshold: [0, 0.2] }) : null;

  function initWondermasChristmas(root = document) {
    root.querySelectorAll('[data-wm2-top]').forEach(anchor => {
      if (anchor.dataset.ready) return;
      anchor.dataset.ready = '1';
      const target = document.querySelector('[id^="MainProduct-"]');
      if (target) anchor.href = '#' + target.id;
    });
    root.querySelectorAll('[data-wm2-autoplay]').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      if (nearby && visible) {
        nearby.observe(video);
        visible.observe(video);
      } else {
        video.dataset.wm2Visible = 'true';
        updatePlayback(video);
      }
    });
  }

  function refreshPlayback() {
    videos.forEach(video => {
      if (video.isConnected) updatePlayback(video);
      else videos.delete(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWondermasChristmas(), { once: true });
  } else {
    initWondermasChristmas();
  }
  document.addEventListener('visibilitychange', refreshPlayback);
  if (motion.addEventListener) motion.addEventListener('change', refreshPlayback);
  document.addEventListener('shopify:section:load', event => initWondermasChristmas(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-wm2-autoplay]').forEach(video => {
      video.pause();
      if (nearby) nearby.unobserve(video);
      if (visible) visible.unobserve(video);
      videos.delete(video);
    });
  });
})();
